import styled from 'styled-components'
import { Button } from '@dsny/dsny-component-library'

export const ModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${({ $isMobile, error }) =>
    error ? 0 : $isMobile ? '14px' : '24px'};
  max-height: ${({ $isMobile }) => ($isMobile ? '70vh' : '')};
  padding-right: 4px;
  overflow-y: ${({ $isMobile }) => ($isMobile ? 'auto' : '')};
  gap: ${({ $state }) => ($state ? '16px' : '32px')};
  align-items: ${({ $state }) => ($state ? 'center' : 'stretch')};
  text-align: ${({ $state }) => ($state ? 'center' : 'left')};
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`

export const XButtonWrapper = styled.div`
  position: absolute;
  right: 25px;

  svg {
    cursor: pointer;
    width: 24px;
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${({ $state }) => ($state ? '8px' : '0px')};
`

export const IconWrapper = styled.div`
  padding: ${({ $isMobile }) => ($isMobile ? '7px' : '0')};
  display: flex;
`

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ListTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const InviteIconBg = styled.div`
  display: flex;
  width: ${({ $isMobile }) => ($isMobile ? '26px' : '48px')};
  height: ${({ $isMobile }) => ($isMobile ? '26px' : '48px')};
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.neutralW100};
  flex-shrink: 0;
`

export const TermsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const TermsContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`

export const ListWrapper = styled.div`
  display: flex;
  margin-bottom: 8px;
  margin-top: 16px;
  justify-content: space-between;
`

export const ListContainer = styled.div`
  margin: 4px 0;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  gap: 16px;
  align-items: center;
`

export const StyledButton = styled(Button)`
  height: 48px;
  align-items: center;
  justify-content: center;
  padding: 0;
`

export const TextFieldDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
